import { render, staticRenderFns } from "./corporate_legal_affairs.vue?vue&type=template&id=07e12918&scoped=true"
import script from "./corporate_legal_affairs.vue?vue&type=script&lang=js"
export * from "./corporate_legal_affairs.vue?vue&type=script&lang=js"
import style0 from "./corporate_legal_affairs.vue?vue&type=style&index=0&id=07e12918&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e12918",
  null
  
)

export default component.exports